import api from '@/api'
import * as types from './types'

export default {
  setSearchTerm({
    commit
  }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({
    commit
  }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({
    commit
  }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({
    commit
  }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setStatus({
    commit
  }, status) {
    commit(types.SET_STATUS, status)
  },
  setFilterBy({
    commit
  }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  initUser({ commit }) {
    commit(types.INIT_USER)
  },
  highlightSave({ commit }, value) {
    commit(types.SET_HIGHLIGHT, value)
  },
  highlightPasswordSave({ commit }, value) {
    commit(types.SET_HIGHLIGHT_PASSWORD, value)
  },
  setUserRole({ commit }, value) {
    commit(types.SET_USER_ROLE, value)
  },
  setSource({ commit }, source) {
    commit(types.SET_SOURCE, source)
  },
  async getUser({ commit, dispatch }, username) {
    return new Promise((resolve, reject) => {
      api.getUser(username)
        .then(response => {
          console.log('getUser', response)
          commit(types.SET_USER, response.data)
          resolve(response)
        })
    })
  },
  async getUsers({ commit, dispatch }, searchOptions) {
    return new Promise((resolve, reject) => {
      api.getUsers(searchOptions)
        .then(response => {
          commit(types.SET_USERS, response.data)
          resolve(response)
        })
    })
  },
  async downloadAllUsers({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.downloadAllUsers()
        .then(response => {
          resolve(response)
        })
    })
  },
  async updateUser({ commit, state }) {
    return new Promise((resolve, reject) => {
      var data = {
        Id: state.user.UserId,
        Roles: state.user.Roles,
        FamilyName: state.user.LastName,
        GivenName: state.user.FirstName,
        Username: state.user.Username,
        Email: state.user.Email,
        DispatchGroupEmail: state.user.DispatchGroupEmail,
        IsActive: state.user.IsActive,
        IsLockedOut: state.user.IsLockedOut,
        RootLocationId: state.user.LocationId,
        IsMahle: state.user.IsMahle,
        ShowRAG: state.user.ShowRAG !== null && state.user.ShowRAG !== undefined ? state.user.ShowRAG : false,
        IsTechpro: state.user.IsTechpro !== null && state.user.IsTechpro !== undefined ? state.user.IsTechpro : false,
        IsTexa: state.user.IsTexa !== null && state.user.IsTexa !== undefined ? state.user.IsTexa : false
      }
      console.log('updateUser', data)
      api.updateUser(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async createUser({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      var user = {
        CreatedBy: data.CreatedBy,
        Roles: state.user.Roles,
        FamilyName: state.user.LastName,
        GivenName: state.user.FirstName,
        Username: state.user.Username,
        Email: state.user.Email,
        DispatchGroupEmail: state.user.DispatchGroupEmail,
        Password: state.user.Password,
        IsActive: state.user.IsActive,
        IsLockedOut: state.user.IsLockedOut,
        RootLocationId: data.LocationId,
        IsMahle: data.IsMahle,
        ShowRAG: state.user.ShowRAG !== null && state.user.ShowRAG !== undefined ? state.user.ShowRAG : false,
        IsTechpro: state.user.IsTechpro !== null && state.user.IsTechpro !== undefined ? state.user.IsTechpro : false,
        IsTexa: state.user.IsTexa !== null && state.user.IsTexa !== undefined ? state.user.IsTexa : false
      }
      console.log('createUser', user)
      api.createUser(user)
        .then(response => {
          resolve(response)
        })
    })
  },
  resetUserPassword({ commit, state }, user) {
    if (user.password === null) {
      alert('Password must be provided.')
      return null
    }
    return new Promise((resolve, reject) => {
      console.log('User Password Reset', user)
      const data = {
        password: user.Password,
        resetLockout: !user.IsLockedOut,
        id: user.UserId
      }
      api.resetUserPassword(data)
        .then(response => {
          alert('Password has been reset successfully!')
          resolve(response)
          commit(types.SET_HIGHLIGHT_PASSWORD, false)
        })
        .catch(error => {
          alert(error.response.data)
          reject(error)
        })
    })
  },
  async checkEmailExists({ commit, state }) {
    var result = false
    console.log('test email', state.user.UserId, state.user.Email)
    return new Promise((resolve, reject) => {
      api.checkEmailExists(state.user.UserId, state.user.Email)
      .then(response => {
        console.log('checked email', response)
        resolve(response)
        result = response.data
        return result
      })
    })
  },
  async checkEmailExistsFor(_, { userId, email }) {
    const response = await api.checkEmailExists(userId || 0, email)
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js